import { useEffect, useRef } from "react";
import { Filter, Search } from "lucide-react";
import Input from "../../../components/Input/Input";
import Select from "../../../components/Select/Select";

const isTypingTarget = (element) =>
  ["INPUT", "TEXTAREA", "SELECT"].includes(element?.tagName) || element?.isContentEditable;

/**
 * "▼ All ⌄ | 🔍 Search [/]" bar from the design, built from the shared Select and Input.
 * statusOptions: [{ id, name }] — the Select's empty first option is "All".
 * `children` renders after the bar (e.g. a week label).
 */
const DiaryFilterBar = ({ statusOptions, status, onStatusChange, search, onSearchChange, searchPlaceholder = "Search", children }) => {
  const searchRef = useRef(null);

  // "/" focuses the search box, as the hint in the design suggests
  useEffect(() => {
    const focusSearch = (event) => {
      if (event.key !== "/" || isTypingTarget(document.activeElement)) return;
      event.preventDefault();
      searchRef.current?.focus();
    };
    document.addEventListener("keydown", focusSearch);
    return () => document.removeEventListener("keydown", focusSearch);
  }, []);

  return (
    <div className="wd-toolbar">
      <div className="wd-filter-bar">
        <div className="wd-filter-bar__select">
          <Filter size={14} aria-hidden="true" />
          <Select
            name="diary_status"
            value={status}
            options={statusOptions}
            placeholder="All"
            onChangeHandler={(event) => onStatusChange(event.target.value)}
            aria-label="Filter by status"
          />
        </div>
        <div className="wd-filter-bar__search">
          <Search size={14} aria-hidden="true" />
          <Input
            ref={searchRef}
            type="search"
            name="diary_search"
            value={search}
            onChangeHandler={(event) => onSearchChange(event.target.value)}
            placeholder={searchPlaceholder}
            aria-label={searchPlaceholder}
          />
          <kbd className="wd-kbd">/</kbd>
        </div>
      </div>
      {children}
    </div>
  );
};

export default DiaryFilterBar;
